import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import Select from "react-select";
import Styles from "./FormDetailAvisDecision.scss";
import { mdiCircle } from "@mdi/js";

const FormDetailAvisDecision = (props) => {
    let serviceState = [
        { value: 0, label: "crée", color: "#8F919A" },
        { value: 1, label: "En attente", color: "#DADADD" },
        { value: 2, label: "Envoyé", color: "#DEF6F3" },
        { value: 3, label: "Suspendu", color: "#F99B84" },
        { value: 4, label: "Répondu", color: "#A7E7DF" },
        { value: 5, label: "Favorable", color: "#58D2C3" },
        { value: 6, label: "Réjeté", color: "#FC7654" },
        { value: 7, label: "Annulé", color: "#414351" },
        { value: 8, label: "Sous-réserve", color: "#FFBC6D" },
        { value: 9, label: "Urgent", color: "#5668EC" },
        { value: 10, label: "Cloturé", color: "#000" },
    ];

    let formRefState = [
        { value: 0, label: "Néant", color: "#C4C4C4" },
        { value: 1, label: "En attente", color: "#F1F1F1" },
        { value: 2, label: "Refus", color: "#FF7168" },
        { value: 3, label: "Sous-réserve", color: "#FFBC6D" },
        { value: 4, label: "Favorable", color: "#58D2C3" },
        { value: 5, label: "Tacite", color: "#CE92FC" },
    ];

    const [options, setOptions] = useState([
        { value: 0, label: "Néant", color: "#C4C4C4" },
    ]);
    const [selected, setSelected] = useState(options[props.state]);

    useEffect(() => {
        setOptions(props.size === "lg" ? formRefState : serviceState);
    }, []);
    useEffect(() => {
        setSelected(props.state ? options[props.state] : options[0]);
    }, [options]);

    const handleChange = (i) => {
        setSelected(options[i]);
        props.size === "lg"
            ? props.onUpdateState(
                  "state_id",
                  options[i].value,
                  props.id,
                  formRefState?.dem_state
              )
            : props.onUpdateState(
                  "state_id",
                  options[i].value,
                  props.item.id,
                  props.item.service_type_id
              );
    };

    return selected ? (
        <div>
            {props.size === "lg" ? (
                <button
                    className={
                        "btn btn-primary btn-block text-left border-0 ue-btn-select-lg"
                    }
                    type="button"
                    data-toggle="dropdown"
                    style={{ paddingTop: "22px" }}
                    aria-expanded="false"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Icon
                            path={mdiCircle}
                            size={0.4}
                            color={selected.color}
                        />
                        <span
                            className={"font-weight-normal"}
                            style={{
                                fontSize: "11px",
                            }}
                        >
                            {selected.label}
                        </span>
                        <i
                            className="bi-chevron-right"
                            style={{ marginLeft: "28rem", display: "block" }}
                        ></i>
                    </div>
                </button>
            ) : (
                <button
                    className={"btn btn-primary btn-sm ue-btn-select-xsm"}
                    type="button"
                    data-toggle="dropdown"
                    style={{ paddingTop: "22px" }}
                    aria-expanded="false"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Icon
                            path={mdiCircle}
                            size={0.4}
                            color={selected.color}
                        />
                        <span className={"font-weight-bold"}>
                            {selected.label}
                        </span>
                        <i
                            className="bi-chevron-right"
                            style={{ marginLeft: "28rem", display: "block" }}
                        ></i>
                    </div>
                </button>
            )}
            <div className="dropdown-menu">
                {options.map((item, index) => {
                    return (
                        <a
                            key={index}
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handleChange(index)}
                        >
                            <Icon
                                path={mdiCircle}
                                size={0.3}
                                color={item.color}
                            />{" "}
                            {item.label}
                        </a>
                    );
                })}
            </div>
        </div>
    ) : null;
};

export default FormDetailAvisDecision;
